import { useState } from "react";
import { Tabs } from "antd";
import { useScopeParams } from "@/hooks/useScopeParams";
import PageHeader from "@/components/UI/PageHeader";
import MonitoringPlanTab from "./MonitoringPlanTab";
import ReviewHeaderStrip from "./ReviewHeaderStrip";
import ReviewHistoryTable from "./ReviewHistoryTable";
import ReviewQueueTable from "./ReviewQueueTable";
import ReviewSettingsDrawer from "./ReviewSettingsDrawer";

export default function MedicalReview() {
  const { id: trialId } = useScopeParams();
  const [settingsOpen, setSettingsOpen] = useState(false);

  if (!trialId) return null;

  return (
    <div className="flex w-full min-w-0 flex-col gap-3 p-4">
      <PageHeader
        title="Medical Review"
        tooltipText="Review new and changed safety data record by record, as it arrives. Marking a record reviewed is your electronic signature over exactly the content shown: your name, the time, and the record's content hash are recorded and kept."
        dataTestId="medical-review-header"
      />

      <ReviewHeaderStrip
        trialId={trialId}
        onOpenSettings={() => setSettingsOpen(true)}
      />

      <Tabs
        defaultActiveKey="queue"
        items={[
          {
            key: "queue",
            label: "Queue",
            children: <ReviewQueueTable trialId={trialId} />,
          },
          {
            key: "history",
            label: "Review history",
            children: <ReviewHistoryTable trialId={trialId} />,
          },
          {
            key: "plan",
            label: "Monitoring plan",
            children: <MonitoringPlanTab trialId={trialId} />,
          },
        ]}
      />

      <ReviewSettingsDrawer
        trialId={trialId}
        open={settingsOpen}
        onClose={() => setSettingsOpen(false)}
      />
    </div>
  );
}
